export enum EventNames {
    ExpandDrawer = 'expandDrawer',
    CollapseDrawer = 'collapseDrawer',
}

export enum DrawerType {
    ALT_VERSIONS = 'altVersions',
    MORE_LIKE_THIS = 'moreLikeThis',
    RECOMMENDED_MUSIC = 'recommendedMusic',
    SAME_SHOOT_SAME_MODEL_SIMILAR_CLIPS = 'sameShootSameModelSimilarClips',
}

interface IDrawerEvent {
    type: string;
    initialItemId?: number;
    drawerType?: DrawerType;
}

class DrawerEvent extends Event {
    public readonly initialItemId?: number;
    public readonly drawerType?: DrawerType;

    constructor({ type, initialItemId, drawerType }: IDrawerEvent) {
        super(type);
        this.initialItemId = initialItemId;
        this.drawerType = drawerType;
    }
}

export class ExpandDrawerEvent extends DrawerEvent {
    static readonly TYPE = 'drawer:expand';

    constructor(initialItemId: number, drawerType?: DrawerType) {
        super({ type: ExpandDrawerEvent.TYPE, initialItemId, drawerType });
    }
}

export class CollapseDrawerEvent extends DrawerEvent {
    static readonly TYPE = 'drawer:collapse';

    constructor(initialItemId: number, drawerType?: DrawerType) {
        super({ type: CollapseDrawerEvent.TYPE, initialItemId, drawerType });
    }
}

export const DRAWER_EVENTS = {
    EXPAND: ExpandDrawerEvent.TYPE,
    COLLAPSE: CollapseDrawerEvent.TYPE,
};
